import Tooltip from "../../../../components/tooltip";
import Simulation from "./Generation/SimulationPPEConsole";
import SurplusDeficitAnalysis from "./Generation/SimulationDeficit";
import SimulationHeader from "../utility/SimulationHeader";
import { useState } from "react";
import { useOptimizerNavigation } from "../utility/useOptimizerNavigation";
import MainHeader from "../utility/DateSession";
import { ErrorPopup } from "../../../../components/ErrorHandling";
import DateRangeSelector from "../DateRange/DateRangeSelector";
import { useSelector } from "react-redux";
import Loading from "../../../../components/Loading";
import ToggleTabs from "../utility/ChartTableToggle";
import MetricsProcurement from "../MetricsProcurement/MetricsIndex";
const DataTabs = ["Volume", "Cost"];
const MainTabs = ["Metrics", "Chart"];

export default function RuvnlSimulationIndex() {
  const { navigateToPage } = useOptimizerNavigation();
  const [activeMainTab, setActiveMainTab] = useState(MainTabs[0]);
  const [error, setError] = useState<string | null>(null);
  const [open, setOpen] = useState(true);
  const [refreshKey, setRefreshKey] = useState(0);
  const [selectedBlock, setSelectedBlock] = useState<any[]>([]);
  const [uniqueTargetDate, setUniqueTargetDate] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const [activeTab, setActiveTab] = useState<string>(DataTabs[0]);

  const preSelectedstartDate = useSelector(
    (state: any) => state.ProcurementOptimizerDemoDate.startDate,
  );
  const preSelectedendDate = useSelector(
    (state: any) => state.ProcurementOptimizerDemoDate.endDate,
  );
  const [selectedTargetDate, setSelectedTargetDate] = useState<
    Array<{ value: string; label: string; isFixed: boolean }>
  >([]);
  const handleDateChange = (
    start: Date | null,
    end: Date | null,
    allDates: Array<{ value: string; label: string; isFixed: boolean }>,
  ) => {
    setSelectedTargetDate(allDates);
  };

  return (
    <>
      <div className="w-full overflow-hidden">
        {loading && <Loading />}
        <MainHeader />
        <div className="h-[calc(-85px+100vh)] p-4 overflow-hidden">
          <div className="w-full h-full flex flex-col gap-4 overflow-hidden">
            <SimulationHeader
              title={
                activeMainTab === "Metrics"
                  ? "Portfolio Metrics"
                  : "Portfolio Insights"
              }
              setActiveTab={setActiveMainTab}
              refreshKey={refreshKey}
              setRefreshKey={setRefreshKey}
            />
            <div className="flex flex-row gap-4 relative flex-1 min-h-0 overflow-hidden">
              <Simulation
                open={open}
                setOpen={setOpen}
                setError={setError}
                refreshKey={refreshKey}
                setRefreshKey={setRefreshKey}
              />

              <div
                className="gas-chart-container !p-0  shadow-[rgba(149,157,165,0.2)_0px_8px_24px] rounded-2xl flex flex-col min-w-0"
                style={{
                  // width: "75%",
                  height: "100%",
                  overflow: "hidden",
                  flex: "1",
                }}
              >
                <div className="flex flex-col h-full w-full min-w-0 overflow-hidden bg-[#FAFBFD]">
                  {/* Header with Date Range and Tabs - Fixed height */}
                  <div className={`flex justify-between items-center p-2 border-b border-[#DFEAF2] bg-[#FFF] flex-shrink-0 min-w-0 ${activeMainTab === "Metrics" ? "mb-0" : "mb-0"}`}>
                    <div className="flex items-center gap-3 min-w-0">
                      {activeMainTab === "Metrics" ? (
                        <h2 className="chartHeading w-60 !text-sm">
                          Key Indicator Snapshot
                        </h2>
                      ) : (
                        <DateRangeSelector
                          placeholder="Select Date Range"
                          startDate={preSelectedstartDate}
                          endDate={preSelectedendDate}
                          onDateChange={handleDateChange}
                        />
                      )}
                    </div>
                    <div className="flex gap-x-3 justify-between flex-shrink-0">
                      <ToggleTabs
                        tabs={MainTabs}
                        activeTab={activeMainTab}
                        setActiveTab={setActiveMainTab}
                      />
                      <div className="w-[1px] h-10 bg-[#34656D]"></div>
                      <ToggleTabs
                        tabs={DataTabs}
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                      />
                    </div>
                  </div>

                  {/* Content area - Takes remaining height */}
                  <div className="flex flex-col gap-3 flex-1 min-h-0 min-w-0 overflow-hidden !bg-[#FCFCFCB8]">
                    {/* Metrics Cards Row - Auto height based on content */}
                    {activeMainTab === "Metrics" ? (
                      <MetricsProcurement
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                        refreshKey={refreshKey}
                      />
                    ) : (
                      <SurplusDeficitAnalysis
                        selectedBlock={selectedBlock}
                        refreshKey={refreshKey}
                        setError={setError}
                        setUniqueTargetDate={setUniqueTargetDate}
                        selectedTargetDate={selectedTargetDate}
                        activeTab={activeTab}
                      />
                    )}
                    {/* <div className="w-full flex-shrink-0 min-w-0 overflow-hidden"> */}
                    {/* {activeTab === "Volume" && (
                          <GnaMetricsVolumeAnalysis
                            selectedBlock={selectedBlock}
                            refreshKey={refreshKey}
                            setError={setError}
                            loading={loading}
                            data={data}
                          />
                        )}
                        {activeTab === "Cost" && (
                          <GnaMetricsCostAnalysis
                            selectedBlock={selectedBlock}
                            refreshKey={refreshKey}
                            setError={setError}
                            loading={loading}
                            data={data}
                          />
                        )} */}
                    {/* </div> */}

                    {/* Charts Row - Takes remaining space */}
                    {/* <div className="w-full flex-1 min-h-0 min-w-0 overflow-hidden"> */}
                    {/* {activeTab === "Volume" && (
                          <SurplusDeficitAnalysis
                            selectedBlock={selectedBlock}
                            refreshKey={refreshKey}
                            setError={setError}
                            setUniqueTargetDate={setUniqueTargetDate}
                            selectedTargetDate={selectedTargetDate}
                            activeTab={activeTab}
                          />
                        )}
                        {activeTab === "Cost" && (
                          <SurplusDeficitAnalysis
                            selectedBlock={selectedBlock}
                            refreshKey={refreshKey}
                            setError={setError}
                            setUniqueTargetDate={setUniqueTargetDate}
                            selectedTargetDate={selectedTargetDate}
                            activeTab={activeTab}
                          />
                        )} */}
                    {/* </div> */}
                  </div>
                </div>

                {/* {activeMainTab === "Optimal" && (
                  <RuvnlOptimalIndex refreshKey={refreshKey} />
                )} */}
                {/* {activeMainTab === "Metrics" && (
                )} */}
              </div>
            </div>
          </div>
        </div>

        <ErrorPopup error={error} onClose={() => setError(null)} />
        <div className="gna-footer-container">
          <div className="grid grid-cols-3 justify-between gap-5">
            <Tooltip
              note={
                <p>
                  {/* Default values and variable charges are auto-fetched from
                  system. */}
                </p>
              }
              text=""
            >
              <p className="gna-footer-text">Source</p>
            </Tooltip>
            <p className="gna-footer-text col-span-1 text-center">
              Powered by <strong>GNA Energy</strong>
            </p>
            <strong className="gna-footer-text col-span-1 text-end">
              Beta Version
            </strong>
          </div>
        </div>
      </div>
    </>
  );
}
